import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PayInResource } from './types';

export default (makeCall: MakeCall) => (uuid: string) =>
  makeCall<PayInResource>('GET', `${APIV2_URL}/payment/pay-in/${uuid}`);
